import React, { ComponentProps } from 'react';

import { useBrandContext } from '~/brands/BrandContext';

import { useSessionContext } from '../../../contexts/SessionContext';
import LogoIcon from '../../../overwrites/assets/LogoIcon';
import LogoIconCollapsed from '../../../overwrites/assets/LogoIconCollapsed';
import { AppImage, LogoContainer } from './Logo.styles';

interface SideBarLogoProps extends ComponentProps<'div'> {
  gradientId?: string;
  collapsed: boolean;
}

export const SideBarLogo = ({ gradientId, collapsed, ...rest }: SideBarLogoProps) => {
  const { me, isOrgAdmin } = useSessionContext();
  const { brand } = useBrandContext();

  return (
    <LogoContainer {...rest}>
      {me &&
        (me?.whiteLabelImageUrl && !isOrgAdmin ? (
          <AppImage src={me?.whiteLabelImageUrl} />
        ) : collapsed ? (
          brand?.logoCollapsed || <LogoIconCollapsed gradientId={gradientId} />
        ) : (
          brand?.logo || <LogoIcon gradientId={gradientId} />
        ))}
    </LogoContainer>
  );
};
